<template>
  <div class="signup bg-gray">
    <b-container class='py-4'>
      <b-row>
        <b-col cols='8' class='mx-auto mt-4'>
          <b-card class='org-session'>
          <div class="container" >

            <h4 class="font-blue text-center pt-4 mt-5">代理店情報の登録</h4>
            <p class="text-center mb-4"><small>貴社の基本情報をご入力ください。<br>下記のボタンをクリックすると求人情報入力画面に進みます。</small></p>
            <validation-observer class="form" ref="obs" >
              <b-row>
                <div class="col-9 mx-auto">
                  <label class="mb-0"><p class="require-badge px-2 inline">{{$t("message.required")}}</p>{{$t("message.company_name")}}</label><br>
                  <small>{{$t("message.note_description")}}</small>
                  <validation-provider name="company_name" rules="required">
                    <div slot-scope="NameProps">
                      <input class="dirty b-w-0 p-2 mt-2" v-model="org_info.name">
                      <p v-if="NameProps.failed" class="error">{{ NameProps.errors[0] }}</p>
                    </div>
                  </validation-provider>
                </div>
              </b-row>

              <b-row>
                <div class="col-9 mx-auto mt-4">
                  <label class="mb-0"><p class="require-badge px-2 inline">{{$t("message.required")}}</p>{{$t("message.person_charge")}}</label><br>
                  <small>{{$t("message.note_description")}}</small>
                  <validation-provider name="person_charge" rules="required">
                    <div slot-scope="ZipProps">
                      <input class="dirty b-w-0 p-2 mt-2" v-model="org_info.charge_name" placeholder="ex）山田 太郎" >
                      <p v-if="ZipProps.failed" class="error">{{ ZipProps.errors[0] }}</p>
                    </div>
                  </validation-provider>
                </div>
              </b-row>
              <b-row>
                <div class="col-9 mx-auto mt-4">
                  <label class="mb-0"><p class="require-badge px-2 inline">{{$t("message.required")}}</p>電話番号</label><br>
                  <small>{{$t("message.note_description")}}</small>
                  <validation-provider name="person_charge_phone" rules="required">
                    <div slot-scope="ChargePhoneProps">
                      <input class="dirty b-w-0 p-2 mt-2" v-model="org_info.phone" placeholder="ex）000-000-0000" >
                      <p v-if="ChargePhoneProps.failed" class="error">{{ ChargePhoneProps.errors[0] }}</p>
                    </div>
                  </validation-provider>
                </div>
              </b-row>

<!--               <b-row>
                <div class="col-9 mx-auto mt-4">
                  <label ><p class="require-badge px-2 inline">{{$t("message.required")}}</p>メールアドレス</label><br>
                  <small>{{$t("message.note_description")}}</small>
                  <validation-provider name="email" rules="required">
                    <div slot-scope="EmailProps">
                      <input class="dirty b-w-0 p-2" v-model="org_info.email" placeholder="">
                      <p v-if="EmailProps.failed" class="error">{{ EmailProps.errors[0] }}</p>
                    </div>
                  </validation-provider>
                </div>
              </b-row> -->

            </validation-observer>

            <b-row>
              <div v-if="isAlready" class="col-5 mx-auto my-5 py-3">
                <b-button block class='bg-orange mt-4 regist-button' @click='patchInfo'>更新</b-button>
              </div>
              <div v-else class="col-5 mx-auto my-5 py-3">
                <b-button block class='bg-orange mt-4 regist-button' @click='registInfo'>{{$t("message.regist_this_content")}}</b-button>
              </div>
            </b-row>
          </div>
        </b-card>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import { ValidationProvider, ValidationObserver} from "vee-validate";
import { mapGetters } from 'vuex';
import axios from 'axios';
export default {
  components: {
    ValidationProvider,
    ValidationObserver
  },
  data () {
    return {
      idToken: localStorage.idToken,
      org_info:{
        name: '',
        email: "",
        phone: '',
        charge_name: ''
      },
      staff_info:{
        name: '',
        phone: '',
        organization_id: ""
      },
      isAlready: false,
      value: '',
      isEstablishedFailed: false,
      isMiss: false,
      scaleOption: {
        'scale1':"1~49人",
        'scale2':"50~99人",
        'scale3':"100~499人",
        'scale4':"500~999人",
        'scale5':"1000人以上",
      }
    }
  },
  methods: {
    onContext(ctx) {
      // The date formatted in the locale, or the `label-no-date-selected` string
      this.formatted = ctx.selectedFormatted
      // The following will be an empty string until a valid date is entered
      this.org_info.established_at = ctx.selectedYMD
    },
    async patchInfo() {
      return this.$refs.obs.validate().then(value =>{
        if(value){
          this.isMiss = false
          axios
          .patch(process.env.VUE_APP_API + "/api/agcy/agency/1", {organization: this.org_info}, {headers: {'Authorization': 'Bearer ' + this.idToken}})
          .then(response => {
            this.$store.commit('agency/setAgency', response.data)
            this.staff_info.name = this.org_info.charge_name
            this.staff_info.phone = this.org_info.phone
            // urlが１になっているがAPIではidtokenを使っているのでダミー
            axios
            .patch(process.env.VUE_APP_API + "/api/agcy/agency_staffs/1", {staff: this.staff_info}, {headers: {'Authorization': 'Bearer ' + this.idToken}})
            .then(response => {
              this.$store.commit('agencystaff/setStaff', response.data)
              this.$router.replace('./mypage')
            }).catch(error => {
              console.log('this is org error', error)
            })
          }).catch(error => {
            console.log('this is org error', error)
          })
        }
        else{
          this.isMiss = true
        }
      }).catch(error => {
        console.log(error)
      })
    },
    async registInfo(){
      return this.$refs.obs.validate().then(value =>{
        if(value){
          this.isMiss = false
          axios
          .post(process.env.VUE_APP_API + "/api/agcy/agency", {organization: this.org_info}, {headers: {'Authorization': 'Bearer ' + this.idToken}})
          .then(response => {
            this.$store.commit('agency/setAgency', response.data)
            this.staff_info.name = this.org_info.charge_name
            this.staff_info.phone = this.org_info.phone
            this.staff_info.agency_id = response.data.agency.id
            // urlが１になっているがAPIではidtokenを使っているのでダミー
            axios
            .patch(process.env.VUE_APP_API + "/api/agcy/agency_staffs/1", {staff: this.staff_info}, {headers: {'Authorization': 'Bearer ' + this.idToken}})
            .then(response => {
              this.$store.commit('agencystaff/setStaff', response.data)
              this.$router.replace('./mypage')
            }).catch(error => {
              console.log('this is org error', error)
            })
          }).catch(error => {
            console.log('this is org error', error)
          })
        }
        else{
          this.isMiss = true
        }
      }).catch(error => {
        console.log(error)
      })
    },
  },
  mounted(){
    if(this.staff == null){
      this.$store.dispatch("agencystaff/fetchStaff", this.idToken)
    }
    axios
      .get(process.env.VUE_APP_API + "/api/agcy/agency/1", {headers: {'Authorization': 'Bearer ' + this.idToken}})
      .then(response => {
        this.org_info = response.data.organization

        if(this.org_info == undefined) {
          this.org_info = {
            name: '',
            email: "",
            phone: '',
            charge_name: ''
          }
        } else {
          this.staff_info.name = this.org_info.charge_name
          this.staff_info.phone = this.org_info.phone
          this.isAlready = true
        }

        this.$store.commit('setLoading', false)
      }).catch(error => {
        console.log('this is agcy error', error)
      })

    console.log(this.staff)
    this.$store.commit('setLoading', false)
  },
  computed: {
    ...mapGetters({
      staff:'agencystaff/getStaff',
    })
  },
}
</script>

<style scoped lang="scss">
.error {
    border-color: red;
    background: mistyrose;
}
.dirty {
    border-color: #F5F5F8;
    background: #F5F5F8;
    width: 100%;
    input{
      border-color: #F5F5F8;
      background: #F5F5F8;
    }
}

.next{
  background: #F29147;
  color: #FFFFFF;
  border-color: #F29147;
}

.org-session{
  border-radius: 1.5rem;
}
.inline{
  display: inline;
}

.regist-button{
  border-radius: 1.5rem;
  font-size: 1.2rem;
}

</style>
